










































































































import {
  CampaignReportData,
  CampaignReportItem,
} from "@/models/CampaignReport";
import CampaignsAPI from "@/services/campaigns";
import { LayoutModule } from "@/store/layout";
import { Component, Prop, Vue } from "vue-property-decorator";
import CampaignReportInfo from "./Components/CampaignReportInfo.vue";
import CampaignReportFilter from "./Components/CampaignReportFilter.vue";
import CampaignReportSummary from "./Components/CampaignReportSummary.vue";
import CampaignReportDetail from "./Components/CampaignReportDetail.vue";
import LineItemReport from "./Components/LineItemReport.vue";
import BaseDivider from "@/components/BaseDivider.vue";
import DatePicker from "@/components/DatePicker.vue";
import AdUnit from "@/models/adUnit";
import DefinitionsAPI from "@/services/definitions";
import AdUnitsAPI from "@/services/adUnits";
import { Dialog, QueryParams } from "@/models/general";
import SitesAPI from "@/services/sites";
import Site from "@/models/site";
import { DefinitionBatch, DefinitionList } from "@/models/definition";
import ClientCampaignsPerformance from "@/views/Reports/ClientCampaignsPerformance/ClientCampaignsPerformance.vue";
import CampaignReportDailyDetail from "./Components/CampaignReportDailyDetail.vue";
import LangSelector from "@/components/LangSelector.vue";
import moment from "moment";
import { get } from "lodash";

@Component({
  components: {
    CampaignReportInfo,
    CampaignReportSummary,
    CampaignReportFilter,
    CampaignReportDetail,
    LineItemReport,
    BaseDivider,
    DatePicker,
    LangSelector,
    ClientCampaignsPerformance,
    CampaignReportDailyDetail,
  },
})
export default class CampaignReport extends Vue {
  @Prop() inputData!: CampaignReportData;
  @Prop({ default: true }) selfContained!: boolean;
  appLogo = require("@/assets/app-logo.png");
  data: CampaignReportData | null = null;
  minDate: string | null = null;
  maxDate: string | null = null;
  dateRange: string[] = [];
  adUnits: AdUnit[] = [];
  definitions: DefinitionList[] = [];
  sites: Site[] = [];
  loading = false;
  defaultLang = "es";
  tab = null;

  async created(): Promise<void> {
    if (this.$route.params.id && this.selfContained) {
      const start_date = this.$route.query["start_date"]
        ? this.$route.query["start_date"]
        : moment().startOf("month").format("YYYY-MM-DD");
      const end_date = this.$route.query["end_date"]
        ? this.$route.query["end_date"]
        : moment().endOf("month").format("YYYY-MM-DD");

      this.loading = true;
      LayoutModule.showLoader();
      this.dateRange = [start_date as string, end_date as string];

      try {
        await this.getAdUnits();
        await this.getDefinitions();
        await this.getSites();
        await this.getReport();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
      LayoutModule.hideLoader();
    } else if (!this.selfContained) {
      this.sites = this.inputData.sites ? this.inputData.sites : [];
      this.adUnits = this.inputData.adUnits ? this.inputData.adUnits : [];
      this.definitions = this.inputData.definitions
        ? this.inputData.definitions
        : [];
      this.data = { ...this.inputData };

      if (this.$route.query.lang) {
        this.defaultLang = this.$route.query.lang as string;
      }
    }
  }

  async getSites(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const r = await SitesAPI.getSites(params);
    this.sites = r.data;
  }

  async getDefinitions(): Promise<void> {
    const r = await DefinitionsAPI.list(-1, -1);
    this.definitions = r.data;
  }

  async getAdUnits(): Promise<void> {
    const params = {
      fields: { ad_unit: ["id", "ref", "name"].join(",") },
      page: {
        size: -1,
      },
    };
    const r = await AdUnitsAPI.list(params);

    this.adUnits = r.data;
  }

  async getReport(): Promise<void> {
    this.loading = true;

    try {
      const r = await CampaignsAPI.getReport(
        this.$route.params.id,
        moment(this.dateRange[0]).format("YYYY-MM-DD 00:00:00"),
        moment(this.dateRange[1]).format("YYYY-MM-DD 00:00:00")
      );
      this.minDate = get(r, "campaign.start");
      this.maxDate = get(r, "campaign.end");
      console.log(this.data);
      this.data = r;
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }

  setRange(range: string[]): void {
    this.dateRange = [...range];
  }

  historicPerformance(): void {
    const dialog = new Dialog();
    dialog.showCancelButton = true;
    dialog.successButton.text = "";
    dialog.width = 1280;
    dialog.title = this.$t(
      "reports.client_campaign_performance.title"
    ) as string;
    dialog.component = ClientCampaignsPerformance;
    dialog.componentProps = {
      inputCompany: get(this.inputData, "campaign.company"),
    };

    LayoutModule.setDialogType("info");
    LayoutModule.setDialog(dialog);

    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        return null;
      }
    );

    LayoutModule.showDialog();
  }

  get startDate(): string {
    if (this.data && !this.selfContained) {
      return moment(this.data.meta.report.start).format("DD/MM/YYYY");
    }
    return "";
  }

  get endDate(): string {
    if (this.data && !this.selfContained) {
      return moment(this.data.meta.report.end).format("DD/MM/YYYY");
    }
    return "";
  }
}
